import React from 'react';
import PricingPlans from '../components/PricingPlans';
import { getBrandConfig } from '../util/domain-utils';

const Pricing = () => {
  const brand = getBrandConfig();

  return (
    <div className="max-w-6xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
      {/* Header Section */}
      <div className="text-center max-w-3xl mx-auto mb-4">
        <h1 className="text-3xl md:text-3xl font-bold text-gray-900 mb-4">Simple, Transparent Pricing</h1>
        <p className="text-gray-600 text-center mt-4 text-md">
          Choose the plan that works best for you and start creating professional resumes today.
        </p>
      </div>
      
      {/* Pricing Plans Component */}
      <PricingPlans />
            
      {/* Features Section */}
      <div className="mt-16 bg-white rounded-lg overflow-hidden border">
        <div className="px-6 py-8">
          <h2 className="text-2xl font-bold text-center mb-8">All Plans Include</h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 text-blue-600 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">ATS-Friendly Templates</h3>
              <p className="text-gray-600">Professionally designed templates that pass Applicant Tracking Systems.</p>
            </div>
            
            <div className="text-center">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 text-blue-600 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Customizable Design</h3>
              <p className="text-gray-600">Easily customize colors, fonts, and layouts to match your personal style.</p>
            </div>
            
            <div className="text-center">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 text-blue-600 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">PDF Downloads</h3>
              <p className="text-gray-600">Download your resume in PDF format for easy sharing and printing.</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* FAQ Section */}
      <div className="mt-16">
  <h2 className="text-2xl font-bold text-center mb-8">Frequently Asked Questions</h2>
  
  <div className="grid md:grid-cols-2 gap-6">
    <div className="bg-white rounded-lg shadow-sm p-6 border">
      <h3 className="text-lg font-semibold mb-2">What payment methods do you accept?</h3>
      <p className="text-gray-600">We accept all major credit cards including Visa, Mastercard, American Express, and Discover.</p>
    </div>
    
    <div className="bg-white rounded-lg shadow-sm p-6 border">
      <h3 className="text-lg font-semibold mb-2">How secure are my payments?</h3>
      <p className="text-gray-600">All payments are secure and processed by trusted payment gateways - Stripe for USD payments and Razorpay for INR payments. Your payment information is never stored on our servers.</p>
    </div>
    
    <div className="bg-white rounded-lg shadow-sm p-6 border">
      <h3 className="text-lg font-semibold mb-2">Is there a money-back guarantee?</h3>
      <p className="text-gray-600">Yes, we offer a 7-day money-back guarantee. If you're not satisfied, simply contact our support team for a full refund.</p>
    </div>
    
    <div className="bg-white rounded-lg shadow-sm p-6 border">
      <h3 className="text-lg font-semibold mb-2">Do you offer discounts for students?</h3>
      <p className="text-gray-600">Yes, we offer special discounts for students. Please contact our support team with your valid student ID for details.</p>
    </div>
    
    <div className="bg-white rounded-lg shadow-sm p-6 border">
      <h3 className="text-lg font-semibold mb-2">Can I purchase a different plan later?</h3>
      <p className="text-gray-600">Yes, you can purchase a different plan at any time. Since our plans are one-time purchases, you'll need to make a new purchase if you want to change plans.</p>
    </div>
    
    <div className="bg-white rounded-lg shadow-sm p-6 border">
      <h3 className="text-lg font-semibold mb-2">How many templates are available?</h3>
      <p className="text-gray-600">We offer over 25 professionally designed templates that are fully customizable and ATS-friendly.</p>
    </div>
  </div>
</div>
      
      {/* Support Section */}
      <div className="mt-16 text-center">
        <h2 className="text-xl font-semibold mb-4">Need help choosing a plan?</h2>
        <p className="text-gray-600 mb-6">Our team is ready to help you find the perfect plan for your needs.</p>
        <a 
          href="mailto:support@resumedesign.ai" 
          className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 transition-colors"
        >
          Contact Support
        </a>
      </div>
    </div>
  );
};

export default Pricing;